import React, {useEffect, useRef, useState} from "react";
import "./style.css";
import Button from "../component/Button/Button";
import useObserver from "../utils/userObserver";
import Pagination from "../component/Pagination/Pagination";
import Filter from "../component/Filter/Filter";
// import InternalLoading from "../component/LoadingSpinner/InternalLoading";
import Spinner from "../component/Spinner/Spinner";
import {FilterType} from "../utils/constants";

export default function PlayGround({
                                       isLoading = false,
                                       isScroll = true,
                                       overrideScroll = false,
                                       isControl = false,
                                       isFilter = false,
                                       isPagination = false,
                                       controls = [],
                                       showSelectAll=false,
                                       isSelectAllChecked=false,
                                       onSelectAllChange=()=>{},
                                       showTotalCount = true,
                                       onSearchChange = () => {
                                       },
                                       onDateChange = () => {
                                       },
                                       onOptionChange = () => {
                                       },
                                       filterOptions = [],
                                       dateFilterDefault = {start: null, end: null},
                                       optionFilterDefault = null,
                                       isSearch = false,
                                       isOptions = false,
                                       isDate = false,
                                       dateFilterClear = false,
                                       maxRangeMonths = null,
                                       totalCount = 0,
                                       currentPage = 0,
                                       itemPerPage = 10,
                                       onPageChange = () => {
                                       },
                                       placeholder,
                                       customFilter,
                                       customFilterClassName,
                                       filterSlot = null,
                                       // Full-width slot under the filter row (e.g. More filters panel)
                                       filterBelow = null,
                                       extraActions = [],
                                       showExtraActions = true,
                                       children,
                                   }) {
    const [matches, ref] = useObserver();

    const bodyRef = useRef(null);

    const [scrollable, setScrollable] = useState(isScroll);

    useEffect(() => {
        if (overrideScroll) {
            setScrollable(true);
        } else {
            if (isScroll) {
                if (!matches.desktop) {
                    setScrollable(false);
                } else {
                    setScrollable(true);
                }
            }
        }
    }, [matches, overrideScroll, isScroll]);


    return (
        <>
            <div className={"playgroundParentContainer"}>
                <div className={"playgroundHeadFootHolder"}>
                    <div className={"playgroundHeader"} ref={ref}>
                        <div className={"playgroundQueryHolder"}>
                            {showSelectAll && <div className={"selectall"}>
                                <label onClick={(e) => e.stopPropagation()} className="custom-checkbox-cell">
                                <input
                                    key={"selectall"}
                                    name="select"
                                    type="checkbox"
                                    className="custom-checkbox"
                                    width={"1rem"}
                                    checked={isSelectAllChecked}
                                    onChange={(e) => {
                                        onSelectAllChange(e.target.checked)
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                />
                                <span className="checkmark"></span>
                                </label>
                            </div>}
                            {isFilter && (<div style={{width:"100%"}} >{filterSlot || <Filter
                                isDateFilter={isDate}
                                isOptionFilter={isOptions}
                                isSearchFilter={isSearch}
                                customFilter={customFilter}
                                customFilterClassName={customFilterClassName}
                                onOptionChange={onOptionChange}
                                onDateChange={onDateChange}
                                onSearchChange={onSearchChange}
                                dateFilterClear={dateFilterClear}
                                maxRangeMonths={maxRangeMonths}
                                extraActions={extraActions}
                                showExtraActions={showExtraActions}
                                options={filterOptions.map((i) => ({id: i, value: i}))}
                                dateFilterDefault={dateFilterDefault}
                                optionFilterDefault={optionFilterDefault}
                                placeholder={{
                                    [FilterType.dateRange]: "Filter by created on",
                                    [FilterType.option]: "Filter by status type",
                                    [FilterType.search]: "Search here...",
                                    ...placeholder,
                                }}
                            />}
                            {/* Full-width row under filters (Lead More filters panel, etc.) */}
                            {filterBelow}
                            </div>)}
                            
                        </div>

                        {isControl && (
                            <div className={"playgroundControlHolder"}>
                                {controls.map((control) => {
                                    return (
                                        <div>
                                            <Button
                                                key={`pl-${control.title}`}
                                                onClick={control.action}
                                                disabled={control.disabled}
                                            >
                                                {control.title}
                                            </Button>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
                <div className={`playgroundBody ${scrollable ? 'scrollable' : ''}`}>
                    <Spinner isSpinning={isLoading}>
                        <>{children}</>
                    </Spinner>
                </div>
                <div className={"playgroundHeadFootHolder"}>
                    {isPagination && totalCount > 10 && (
                        <div className={"playgroundFooter"}>
                            {showTotalCount && totalCount > 0 && (
                                <div style={{ 
                                    paddingRight: '10px',
                                    fontSize: '14px', 
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    whiteSpace: 'nowrap'
                                }}>
                                    Total: {totalCount}
                                </div>
                            )}
                            <Pagination
                                onPageChange={(val) => {
                                    onPageChange(val);
                                }}
                                totalCount={totalCount}
                                currentPage={currentPage}
                                pageSize={itemPerPage}
                                siblingCount={matches.mobile ? 0 : 1}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
